import { CreativeTagEvent, CreativeTagTracking } from '../enums';

export const eventByTrackingMap: Map<
  CreativeTagEvent,
  CreativeTagTracking
> = new Map<CreativeTagEvent, CreativeTagTracking>([
  [CreativeTagEvent.CreativeInit, CreativeTagTracking.Init],
  [CreativeTagEvent.CreativeRequested, CreativeTagTracking.Request],
  [CreativeTagEvent.CreativeAssetLoad, CreativeTagTracking.Load],
  [CreativeTagEvent.CreativeLoaded, CreativeTagTracking.Installed],
  [CreativeTagEvent.CreativeLoadingFailed, CreativeTagTracking.Fail],
  [CreativeTagEvent.CreativeDisplay, CreativeTagTracking.Display],
  [CreativeTagEvent.CreativeView, CreativeTagTracking.View],
  [CreativeTagEvent.CreativeTimespent, CreativeTagTracking.Timespent],
  [CreativeTagEvent.CreativeShow, CreativeTagTracking.Show],
  [CreativeTagEvent.CreativeClicked, CreativeTagTracking.Click],
  [CreativeTagEvent.CreativeReached, CreativeTagTracking.Reach],
  [CreativeTagEvent.CreativeCompleted, CreativeTagTracking.Complete],
  [CreativeTagEvent.CreativeChapterViewed, CreativeTagTracking.ChapterViewed],
  [
    CreativeTagEvent.CreativeNavigationSlide,
    CreativeTagTracking.NavigationSlide
  ],
  [
    CreativeTagEvent.CreativeNavigationSiteScroller,
    CreativeTagTracking.NavigationSiteScroller
  ],
  [CreativeTagEvent.CreativeRedirection, CreativeTagTracking.Redirection],

  [CreativeTagEvent.VideoStart, CreativeTagTracking.VideoStart],
  [CreativeTagEvent.VideoFirstQuartile, CreativeTagTracking.VideoFirstQuartile],
  [CreativeTagEvent.VideoMidpoint, CreativeTagTracking.VideoMidpoint],
  [CreativeTagEvent.VideoThirdQuartile, CreativeTagTracking.VideoThirdQuartile],
  [CreativeTagEvent.VideoComplete, CreativeTagTracking.VideoComplete]
]);
